import styled, {css} from "styled-components/macro";
import {device} from "../../styles";
import {IsActive} from "../../data";

export const Root = styled.div<IsActive & {$slideOffset: number}>`
    width: 100%;
    height: 100%;
    z-index: 200;
    transition: height 0.5s ease;

    ${device.less768} {
        width: 100%;
        flex: 0 0 100%;
        padding: 0;
        position: relative;
        overflow: hidden;
        transition: transform 0.5s ease-out;

        ${(props) => props.$isActive && css`
            margin-bottom: 0;
            transform: translateY(${props.$slideOffset * -1}px);
        `}
    }
`;

export const ScrollableContainer = styled.div<IsActive>`
    width: 100%;
    position: sticky;
    top: 0;
    bottom: 0;
    z-index: 200;
    padding: 3vh 0 7vh;

    ${device.less768} {
        position: static;
        top: auto;
        bottom: auto;
        height: 100vh;
        transition: height 0.5s ease-out;
        display: flex;
        justify-content: center;
        align-items: center;

        box-shadow: inset 0 73px 300px -50px rgba(0, 0, 0, 0.05);

        ${(props) => props.$isActive && css`
            height: 50vh;
        `}
    }
`;

export const ScreenshotContainer = styled.div`
    ${device.less768} {
        display: flex;
        justify-content: center;
        align-items: center;
    }
`;


export const ResultContainer = styled.div<{ $width: number, $height: number, $baseHeight: string }>`
    max-width: 600px;
    margin: 0 auto;
    position: relative;
    
    ${(props) => css`
        width: calc(${props.$baseHeight} * ${props.$width} / ${props.$height});
        height: ${props.$baseHeight};
    `}
`;

export const RandomContainer = styled.div`
    position: absolute;
    bottom: 40px;
    left: 0;
    z-index: 210;
    
    ${device.less768} {
        display: none;
    }
`;
